import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfCalendarTimeInAppGoalService } from '../../../core/application/services/goals/get-self-calendar-time-in-app-goal.service';
import { SelfCalendarTimeInAppGoalEntity } from '../../../core/domain/entities/goals/app-goals/self-calendar-time-in-app-goal.entity';
import { GetSelfGoalSummaryRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';

export class GetSelfCalendarTimeInAppGoalQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfCalendarTimeInAppGoalService
  ) {}
  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfCalendarTimeInAppGoalEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
